import React, { Component } from 'react';
import getContract, {getTotalContractTransactions, getAutoRunContract, getAutoRun2Contract, getTbiContract, getAutoRun3Contract} from '../../services/contract';
import getTokenContract from '../../services/tokenContract'
import { ethers } from 'ethers';
import levelPrices from '../../services/levelPrice';
import getWallet from '../../services/wallet';
import Slot from './tree/slot';
import { TransactionService } from '../../services/transactionService';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import withWrapper from '../../helpers/withWrapper';
import ImageZoom from './ImageZoom';
import { getLastActivities } from '../../services/activities';
import moment from "moment";

class Dashboard extends Component {

    state = {
        userAddress: '',
        isWalletConnected: false,
        isAuthorized: false,
        levelBought: 0,
        reinvestCounts: new Array(4).fill(0),
        dataLoaded: false,
        origRef: 0,
        partners: 0,
        userId: 0,
        activities: [],
        contractAddress: '',
        totalTxn: 0,
        totalInvested: 0,
        partnerRewards: 0,
        userIncomeAutoRun: 0,
        userIncomeAutoRun2: 0,
        tbiTokens: 0,
        isUserRegisteredInAutoRun: false,
        isUserRegisteredInAutoRun2: false,
        isUserRegisteredInAutoRun3: false,
        eligibilityTime: ''
    };

    notify = (message) => toast(message);

    constructor(props) {
        super(props);
        const totalLevels = 5;
        const treeNodes = 31;
        let idsArray = new Array(totalLevels).fill(0).map(() => new Array(treeNodes).fill(0));
        this.state.idsWithLevels = idsArray;
        if(props.router.params.id) {
            this.state.userId = props.router.params.id;
        } else {
            this.state.userId = 1;
        }
        this.props.onSetUserId(this.state.userId);
    }

    getActivitiesData = async () => {
        const activities = await getLastActivities(10);
        this.setState({activities});
    }

    initializeState = async (connectedWalletAddress) => {
        const contract = await getContract();
        const autorunContract = await getAutoRunContract();
        const autorun2Contract = await getAutoRun2Contract();
        const autorun3Contract = await getAutoRun3Contract();

        let userId = this.state.userId;

        const totalMembers = ethers.BigNumber.from(await contract.lastIDCount()).toNumber();
        if(totalMembers < userId) {
            alert(`User with id ${userId} not found`);
            userId = 1;
        }

        const userAddress = await contract.getAddressById(userId);
        console.log(userAddress);

        const totalValueInvested = ethers.BigNumber.from(await contract.totalValueInvested()).toString();

        const userInfoResponse = await contract.userInfos(userId);
        
        const levelBought = ethers.BigNumber.from(userInfoResponse["levelBought"]).toNumber();
        
        let partnerRewardsTotal = 0;
        for(let i = 0; i < levelBought; i++) {
            const partnerRewardsHolded = await contract.userPartnerRewardsPaymentHoldings(userId, i+1);
            partnerRewardsTotal += parseFloat(ethers.utils.formatUnits(partnerRewardsHolded, "mwei"));
        }
        
        const userIncomeBig = await autorunContract.userIncome(userId);
        const userIncomeAutoRun = parseFloat(ethers.utils.formatUnits(userIncomeBig, "mwei"));
        let userTotalIncome = parseFloat(ethers.utils.formatUnits(userInfoResponse["totalIncome"], "mwei"));
        userTotalIncome += userIncomeAutoRun;
        
        const userIncome2Big = await autorun2Contract.userIncome(userId);
        const userIncomeAutoRun2 = parseFloat(ethers.utils.formatUnits(userIncome2Big, "mwei"));
        userTotalIncome += userIncomeAutoRun2;

        const userIncome3Big = await autorun3Contract.userIncome(userId);
        const userIncomeAutoRun3 = parseFloat(ethers.utils.formatUnits(userIncome3Big, "mwei"));
        userTotalIncome += userIncomeAutoRun3;

        const multiPayoutEarning = parseFloat(ethers.utils.formatUnits(userInfoResponse["multiPayoutEarning"], "mwei")).toFixed(2);
        
        const origRef = ethers.BigNumber.from(userInfoResponse["origRef"]).toNumber();
        const partners = ethers.BigNumber.from(userInfoResponse["partners"]).toNumber();

        const reinvestCountsResponse = await contract.getRecycles(userId);
        const reinvestCounts = reinvestCountsResponse.map(c => ethers.BigNumber.from(c).toNumber());

        const valueInvestedBN = await contract.totalValueInvested();
        const totalInvested = +ethers.utils.formatUnits(valueInvestedBN, "mwei");

        let userWithLevels = this.state.idsWithLevels;
        try {
          const ids = await contract.getAllSlotTrees(userId);
          console.log(ids);
          for(let i = 0; i < 5; i++) {
            ids[i].forEach((response, index) => {
                const id = ethers.BigNumber.from(response).toNumber();
                userWithLevels[i][index] = id;
              });
          }
        } catch (error) {
          console.log(error.message);
        }

        const isUserRegisteredInAutoRun = await autorunContract.isUserRegisteredInAutoRun(userId);
        const isUserRegisteredInAutoRun2 = await autorun2Contract.isUserRegisteredInAutoRun(userId);
        const isUserRegisteredInAutoRun3 = await autorun3Contract.isUserRegisteredInAutoRun(userId);

        if(connectedWalletAddress?.toLowerCase() == userAddress.toLowerCase()) {
            this.setState({isAuthorized: true})
        }

        const userTokensToClaim_B = await autorun2Contract.newUserClaimableTokens(userId);
        const userTokensToClaim = ethers.BigNumber.from(userTokensToClaim_B).toNumber();
        
        const eligibilityExpiryTime_inSec = ethers.BigNumber.from(await contract.userEligibilityExpiryTime(userId)).toNumber();
        const eligibilityExpiryTime_inMiliSec = (eligibilityExpiryTime_inSec) * 1000;

        let eligibilityTime = '';

        const startDate = Date.now();
        let formatDate = moment.duration(eligibilityExpiryTime_inMiliSec - startDate)

        if (formatDate && (eligibilityExpiryTime_inMiliSec >= startDate)) {
            if (formatDate.months() > 0) {
                eligibilityTime = `${Math.round(formatDate.asDays())}d ${formatDate.hours()}h ${formatDate.minutes()}m`
            }
            else {
                eligibilityTime = `${formatDate.days()}d ${formatDate.hours()}h ${formatDate.minutes()}m`
            }
        } else {
            eligibilityTime = "0d 0h 0m"
        }   
        
        this.setState({ eligibilityTime, userIncomeAutoRun, userIncomeAutoRun2, userIncomeAutoRun3, partnerRewards: partnerRewardsTotal, userId, userAddress, userTotalIncome, totalMembers, totalValueInvested, origRef, partners,
            isUserRegisteredInAutoRun, isUserRegisteredInAutoRun2, isUserRegisteredInAutoRun3, tbiTokens: userTokensToClaim, levelBought, totalInvested, reinvestCounts, multiPayoutEarning, idsWithLevels: userWithLevels, dataLoaded: true, contractAddress: contract.address});
    }

    async componentDidMount() {
        await this.init();
    }

    async init() {
        const wallet = await getWallet();
        const connectedWallet = await wallet.signer?.getAddress();
        if(!wallet.isReadOnly) {
            this.setState({isWalletConnected: true});
            // if(id1Wallets.some(wallet => wallet.toLowerCase() == connectedWallet.toLowerCase())) {
            //     this.setState({isId1WalletConnected: true});
            // }
        }

        const count = await getTotalContractTransactions();
        this.setState({totalTxn: count});

        const promise = this.initializeState(connectedWallet);
        

          await toast.promise(
            promise,
              {
                pending: 'Fetching data wait...',
                success: 'Ready to view!',
                error: 'Error fetching data'
              }
          )
    }

    handleCopy = () => {
        if (navigator.clipboard) {
            var textarea = document.createElement("textarea");
            textarea.textContent = this.state.userAddress;
            textarea.style.position = "fixed";
            textarea.style.width = '2em';
            textarea.style.height = '2em';
            textarea.style.padding = 0;
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';
            textarea.style.background = 'transparent';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try {
                document.execCommand("copy");
                document.body.removeChild(textarea);
                this.notify("Copied to clipboard");
            }
            catch (e) {
                document.body.removeChild(textarea);
            }
            // this.notify("Copying not supported in this dapp browser");
        } else {
            navigator.clipboard.writeText(this.state.userAddress).then(() => {
                this.notify("Copied to clipboard");
            }).catch((err) => {
                this.notify(err);
            })
        }
    }

    handleCopyContract = () => {
        if (navigator.clipboard) {
            var textarea = document.createElement("textarea");
            textarea.textContent = this.state.contractAddress;
            textarea.style.position = "fixed";
            textarea.style.width = '2em';
            textarea.style.height = '2em';
            textarea.style.padding = 0;
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';
            textarea.style.background = 'transparent';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try {
                document.execCommand("copy");
                document.body.removeChild(textarea);
                this.notify("Copied to clipboard");
            }
            catch (e) {
                document.body.removeChild(textarea);
            }
            // this.notify("Copying not supported in this dapp browser");
        } else {
            navigator.clipboard.writeText(this.state.contractAddress).then(() => {
                this.notify("Copied to clipboard");
            }).catch((err) => {
                this.notify(err);
            })
        }
    }

    handleRefLinkCopy = () => {
        if (navigator.clipboard) {
            // this.notify("Copying not supported in this dapp browser");
            var textarea = document.createElement("textarea");
            textarea.textContent = 'https://tbi24.money/join?refId=' + this.state.userId;
            textarea.style.position = "fixed";
            textarea.style.width = '2em';
            textarea.style.height = '2em';
            textarea.style.padding = 0;
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';
            textarea.style.background = 'transparent';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try {
                document.execCommand("copy");
                document.body.removeChild(textarea);
                this.notify("Copied to clipboard");
            }
            catch (e) {
                document.body.removeChild(textarea);
            }
        } else {
            navigator.clipboard.writeText('https://tbi24.money/join?refId=' + this.state.userId).then(() => {
                this.notify("Copied to clipboard");
            }).catch((err) => {
                this.notify(err);
            })
        }
    }

    handleBuyLevel = async (level) => {
        const wallet = await getWallet();
        if(wallet.isReadOnly) {
            this.notify("Please connect your wallet");
            return;
        }
        const userBrowserAddresses = await wallet.provider.listAccounts();
        if(this.state.userAddress !== userBrowserAddresses[0]) {
            this.notify("You can't Buy for other person's, if its yours then connect your wallet with this ID");
            return;
        }
        try {
            var transactionService = new TransactionService(this.state.userId, this.state.userAddress);
            const buyLevelPromise = transactionService.buyLevel(level);
            await toast.promise(
                buyLevelPromise,
                {
                  pending: 'Transaction in process please wait...',
                  success: 'Upgrade Completed! 👌',
                  error: 'Upgrade failed '
                }
            )
            await this.initializeState(this.state.userAddress);
        } catch (error) {
            alert(error.message);
        }
    }

    handleAutorunBuy = async () => {
        const wallet = await getWallet();
        if(wallet.isReadOnly) {
            this.notify("Please connect your wallet");
            return;
        }
        const userBrowserAddresses = await wallet.provider.listAccounts();
        if(this.state.userAddress !== userBrowserAddresses[0]) {
            this.notify("You can't Buy for other person's, if its yours then connect your wallet with this ID");
            return;
        }
        try {
            var transactionService = new TransactionService(this.state.userId, this.state.userAddress);
            const autorunPromise = transactionService.joinAutorun();
            await toast.promise(
                autorunPromise,
                {
                  pending: 'Transaction in process please wait...',
                  success: 'Join Successfully! 👌',
                  error: 'Joining failed '
                }
            )
            await this.initializeState(this.state.userAddress);
        } catch (error) {
            alert(error.message);
        }
    }

    handleAutorun2Buy = async () => {
        const wallet = await getWallet();
        if(wallet.isReadOnly) {
            this.notify("Please connect your wallet");
            return;
        }
        const userBrowserAddresses = await wallet.provider.listAccounts();
        if(this.state.userAddress !== userBrowserAddresses[0]) {
            this.notify("You can't Buy for other person's, if its yours then connect your wallet with this ID");
            return;
        }
        try {
            var transactionService = new TransactionService(this.state.userId, this.state.userAddress);
            const autorunPromise = transactionService.joinAutorun2();
            await toast.promise(
                autorunPromise,
                {
                  pending: 'Transaction in process please wait...',
                  success: 'Join Successfully! 👌',
                  error: 'Joining failed '
                }
            )
            await this.initializeState(this.state.userAddress);
        } catch (error) {
            alert(error.message);
        }
    }

    handleAutorun3Buy = async () => {
        const wallet = await getWallet();
        if(wallet.isReadOnly) {
            this.notify("Please connect your wallet");
            return;
        }
        const userBrowserAddresses = await wallet.provider.listAccounts();
        if(this.state.userAddress !== userBrowserAddresses[0]) {
            this.notify("You can't Buy for other person's, if its yours then connect your wallet with this ID");
            return;
        }
        try {
            var transactionService = new TransactionService(this.state.userId, this.state.userAddress);
            const autorunPromise = transactionService.joinAutorun3();
            await toast.promise(
                autorunPromise,
                {
                  pending: 'Transaction in process please wait...',
                  success: 'Join Successfully! 👌',
                  error: 'Joining failed '
                }
            )
            await this.initializeState(this.state.userAddress);
        } catch (error) {
            alert(error.message);
        }
    }

    handleClaim = async () => {
        const wallet = await getWallet();
        if(wallet.isReadOnly) {
            this.props.onError("You can't claim for other Id")
            // alert("Please connect your wallet");
            return;
        }
        const userBrowserAddresses = await wallet.provider.listAccounts();
        if(this.state.userAddress !== userBrowserAddresses[0]) {
            this.props.onError("You can't claim for other Id")
            // alert("You can't claim for other Id");
            return;
        }
        if(this.state.partners < 2) {
            this.props.onError("Partners should be greater than 2")
        }
        try {
            const contract = await getContract();
            const promise = contract.withdrawPartnerRewards()
            await toast.promise(
                promise,
                {
                  pending: 'Partner Rewards claiming for all opened ranks',
                  success: 'Claimed 👌',
                  error: 'Failed '
                }
            )
        } catch (error) {
            alert(error.message);
        }
        
    }

    activateForNext30Days = async () => {
        const wallet = await getWallet();
        if(wallet.isReadOnly) {
            this.props.onError("You can't claim for other Id")
            // alert("Please connect your wallet");
            return;
        }
        const userBrowserAddresses = await wallet.provider.listAccounts();
        if(this.state.userAddress !== userBrowserAddresses[0]) {
            this.props.onError("You can't claim for other Id")
            return;
        }
        
        try {
            var transactionService = new TransactionService(this.state.userId, this.state.userAddress);
            const promise = transactionService.payEligibilityFee();
            await toast.promise(
                promise,
                {
                  pending: 'Paying eligibility fee',
                  success: 'Payment successful 👌',
                  error: 'Failed '
                }
            )
        } catch (error) {
            alert(error.message);
        }
    }

    handleTbiClaim = async () => {
        const wallet = await getWallet();
        if(wallet.isReadOnly) {
            this.props.onError("You can't claim for other Id")
            // alert("Please connect your wallet");
            return;
        }
        const userBrowserAddresses = await wallet.provider.listAccounts();
        if(this.state.userAddress !== userBrowserAddresses[0]) {
            this.props.onError("You can't claim for other Id")
            // alert("You can't claim for other Id");
            return;
        }
        try {
            const contract = await getTbiContract();
            const promise = contract.claimTokens()
            await toast.promise(
                promise,
                {
                  pending: 'Claiming TBI tokens...',
                  success: 'Tokens sent to your wallet 👌',
                  error: 'Failed '
                }
            )
        } catch (error) {
            alert(error.message);
        }
        
    }

    getIdClass = (id) => {
        return (id == 0) ? "bg-white-100" : "bg-white";
    }
    render() { 

        // background-color: #ffeaa7;
        // background-image: linear-gradient(315deg, #ffeaa7 0%, #000000 74%);
        return (
            <div style={{ backgroundColor: "#000000"}} 
                className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14">
                    <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
                        {/* Top Panel, Matrix levels and all activies inside below div */}
                        <div className="flex flex-col w-full space-y-10 sm:space-y-5">
                            {/* Top panel of Dashboard mobile view inside below div */}
                            <div className="flex w-full items-start justify-between space-x-10 lg:space-x-2.5 sm:space-x-0 sm:space-y-5 sm:flex-col sm:px-5">
                                <div className="flex items-start flex-shrink-0 sm:flex-shrink">
                                    <div
                                        className="flex-shrink-0 relative w-25 h-30 rounded-full cursor-pointer sm:w-15 sm:h-15">
                                        <div className=" w-40 h-16 sm:h-20 sm:w-20 rounded-full p-2">
                                            {/* <ImageZoom level={this.state.levelBought} /> */}
                                            <img
                                                src={`/logo/TBI logo.png`} />
                                        </div>

                                    </div>
                                    <div className="flex flex-col items-start ml-10 h-full justify-center my-auto">
                                        <div className="flex justify-center items-center mb-1 sm:mb-2.5"><h2
                                                className="text-white font-bold text-3xl mr-2.5 sm:text-xl cursor-pointer showContractId">ID {this.state.userId} </h2>
                                        </div>
                                        <div className="flex flex-col items-start">
                                            <div className="flex items-center mb-1">
                                                    <span
                                                    className="text-white font-bold mr-2.5 text-base sm:text-sm showWalletAddress">
                                                    {(this.state.userAddress != '') ? (this.state.userAddress.slice(0, 4) + '...' + this.state.userAddress.slice(this.state.userAddress.length - 4, this.state.userAddress.length))
                                                        : ''}
                                                    </span>
                                                    <button className="copyAddress" onClick={this.handleCopy} style={{':hover': { 'content': 'Copy address'} }}><svg className="w-5 h-5"
                                                        viewBox="0 0 20 20" fill="#fff" 
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M15 6.667H8.332c-.92 0-1.667.746-1.667 1.666V15c0 .92.746 1.667 1.667 1.667h6.666c.92 0 1.667-.747 1.667-1.667V8.333c0-.92-.746-1.666-1.667-1.666Z">
                                                        </path>
                                                        <path clipRule="evenodd"
                                                            d="M3.469 3.468A2.167 2.167 0 0 1 5 2.833h6.666A2.167 2.167 0 0 1 13.834 5v1.667a.5.5 0 0 1-1 0V5a1.167 1.167 0 0 0-1.167-1.167H5.001A1.167 1.167 0 0 0 3.834 5v6.667a1.167 1.167 0 0 0 1.167 1.166h1.666a.5.5 0 1 1 0 1H5.001a2.167 2.167 0 0 1-2.167-2.166V5c0-.575.228-1.126.635-1.532Z">
                                                        </path>
                                                    </svg></button></div>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)"}} className="relative flex flex-grow max-w-500px w-full h-full flex-col p-5 justify-between bg-black-light rounded sm:max-w-full">
                                    <div className="flex items-center"><h3 className="text-white text-base sm:text-sm">My joining link</h3></div>
                                    <div className="md:flex flex-wrap justify-between false">
                                        <span style={{ color: '#ffff00' }}
                                            className="text-blue-600 text-lg font-bold lg:mb-2.5 sm:text-xl refferalLink break-all"
                                            id="refferalLink">https://tbi24.money/join?refId={this.state.userId}</span>
                                        <div className="flex space-x-2.5">
                                            <button onClick={this.handleRefLinkCopy}
                                                className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-0 py-0 bg-transparent !leading-30px copyReferral">
                                                <svg className="w-5 h-5 stroke-current text-white" viewBox="0 0 20 20"
                                                    fill="#ffff00" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M15 6.667H8.332c-.92 0-1.667.746-1.667 1.666V15c0 .92.746 1.667 1.667 1.667h6.666c.92 0 1.667-.747 1.667-1.667V8.333c0-.92-.746-1.666-1.667-1.666Z">
                                                    </path>
                                                    <path clipRule="evenodd"
                                                        d="M3.469 3.468A2.167 2.167 0 0 1 5 2.833h6.666A2.167 2.167 0 0 1 13.834 5v1.667a.5.5 0 0 1-1 0V5a1.167 1.167 0 0 0-1.167-1.167H5.001A1.167 1.167 0 0 0 3.834 5v6.667a1.167 1.167 0 0 0 1.167 1.166h1.666a.5.5 0 1 1 0 1H5.001a2.167 2.167 0 0 1-2.167-2.166V5c0-.575.228-1.126.635-1.532Z">
                                                    </path>
                                                </svg>
                                            </button>
                                        </div>
                                        <div
                                            className="flex justify-between items-center text-left border-t border-white-100 w-full mt-2.5 pt-2.5">
                                            <div className="flex flex-wrap text-white mr-1.5">
                                                {/* <div className="mr-1.5">Not a member yet? </div> */}
                                                <div>Join with <span className="whitespace-nowrap">this upline</span>
                                                </div>
                                            </div>
                                            <a
                                                id="hideSignUpButton">
                                                <button style={{backgroundColor: "#E5D858", fontSize: '22px', color: "black"}}
                                                    onClick={() => this.props.navigateToRegister(this.state.userId)} className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none py-0 px-2.5 bg-blue-600 text-white rounded !leading-30px hover:bg-blue-500 active:bg-active-main-blue w-max flex-shrink-0">Join</button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Top panel of Dashboard mobile view inside above div */}

                            {/* Top panel Partners, Team, Profit ration, Profits View inside below div */}
                            <div className="flex w-full mt-15 sm:mt-5 sm:px-5">
                                <div className="flex w-full flex-wrap lg:flex-col">
                                    <div className="flex mr-10 space-x-10 lg:mr-0 lg:mt-10 sm:mt-5 sm:space-x-5 lg:order-2 sm:overflow-auto sm:w-full">
                                        <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem"}}
                                            className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                                            <div className="flex justify-center">
                                                <h2 className="text-white text-center text-base sm:text-sm sm:whitespace-nowrap">Partners</h2>
                                            </div>
                                            <span className="text-white text-center text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">{this.state.partners}</span>
                                        </div>
                                        <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem"}}
                                            className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                                            <div className="flex justify-center"><h2 className="text-white text-center text-base sm:text-sm sm:whitespace-nowrap">Sponser ID</h2>
                                            </div>
                                            <span className="text-white text-center text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5" id="yourTeamTreeCount">{this.state.origRef}</span>
                                        </div>
                                        <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem"}}
                                            className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                                            <div className="flex justify-center">
                                                <h2 className="text-white text-center text-base sm:text-sm sm:whitespace-nowrap">Level Income</h2>
                                            </div>
                                            <span className="text-white text-center text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">{this.state.multiPayoutEarning}</span>
                                        </div>
                                        
                                    </div> 
                                    {/* <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem" }}
                                        className="flex flex-1 max-h-140px sm:max-w-full overflow-hidden w-full relative justify-center items-end bg-black-light rounded lg:max-w-full desktop-infoblock-chart-base">
                                        <div className="flex-shrink-0 flex flex-col p-5 rounded desktop-infoblock-base sm:mobile-infoblock-base">
                                            <div className="flex justify-center">
                                                <h2 className="text-white text-center text-base sm:text-sm sm:whitespace-nowrap">Total AutoRun Income</h2>
                                            </div>
                                            <span className="text-white text-center text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">{this.state.userIncomeAutoRun} USDT</span>
                                        </div>
                                    </div> */}
                                    <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem"}}
                                        className="flex flex-1 max-h-140px sm:max-w-full overflow-hidden w-full relative justify-center items-end bg-black-light rounded lg:max-w-full desktop-info block-chart-base">
                                        <div className="flex-shrink-0 flex flex-col p-5 rounded desktop-infoblock-base sm:mobile-infoblock-base">
                                            <div className="flex justify-center">
                                                <h2 className="text-white text-center text-base sm:text-sm sm:whitespace-nowrap">Total Income</h2>
                                            </div>
                                            <span className="text-white text-center text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">{this.state.userTotalIncome} USDT</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex w-full mt-15 sm:mt-5 sm:px-5">
                                <div className="flex w-full flex-wrap lg:flex-col">
                                    <div className="flex mr-10 space-x-10 lg:mr-0 lg:mt-10 sm:mt-5 sm:space-x-5 lg:order-2 sm:overflow-auto sm:w-full">
                                        <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem"}}
                                            className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-info block-base sm:mobile-infoblock-base">
                                            <div className="flex justify-center">
                                                <h2 className="text-white text-center text-base sm:text-sm sm:whitespace-nowrap">Partner Rewards Holded</h2>
                                            </div>
                                            <span className="text-white text-center text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">{this.state.partnerRewards}</span>
                                            <button style={{background: 'white'}}
                                                className="flex justify-center items-center text-center text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-2 bg-blue-600 hover:bg-blue-400 active:bg-active-red-600 mt-3 py-2 !px-10 sm:py-2 sm:mt-7.5"
                                                onClick={this.handleClaim} id="nextButton" >Claim</button>
                                        </div>

                                        
                                    </div>
                                   {/* <div className="flex mr-10 space-x-10 lg:mr-0 lg:mt-10 sm:mt-5 sm:space-x-5 lg:order-2 sm:overflow-auto sm:w-full">
                                        <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem"}}
                                            className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-info block-base sm:mobile-infoblock-base">
                                        <div className="flex justify-center">
                                                <h2 className="text-white text-center text-base sm:text-sm sm:whitespace-nowrap">Claimable Tokens</h2>
                                            </div> 
                                            <span className="text-white text-center text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">{this.state.tbiTokens}</span>
                                           <button style={{background: 'white'}}
                                                className="flex justify-center items-center text-center text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-2 bg-blue-600 hover:bg-blue-400 active:bg-active-red-600 mt-3 py-2 !px-10 sm:py-2 sm:mt-7.5"
                                                onClick={this.handleTbiClaim} id="nextButton" >Claim</button> 
                                        </div> 
                                        
                                    </div> */}
                                    <div className="flex mr-10 space-x-10 lg:mr-0 lg:mt-10 sm:mt-5 sm:space-x-5 lg:order-2 sm:overflow-auto sm:w-full">
                                        <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem"}}
                                            className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-info block-base sm:mobile-infoblock-base">
                                            <div className="flex justify-center">
                                                <h2 className="text-white text-center text-base sm:text-sm sm:whitespace-nowrap">Total AutoRun Income</h2>
                                            </div>
                                            <span className="text-white text-center text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">{this.state.userIncomeAutoRun} USDT</span>
                                        </div>

                                    </div>
                                    <div className="flex mr-10 space-x-10 lg:mr-0 lg:mt-10 sm:mt-5 sm:space-x-5 lg:order-2 sm:overflow-auto sm:w-full">
                                        <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem"}}
                                            className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-info block-base sm:mobile-infoblock-base">
                                            <div className="flex justify-center">
                                                <h2 className="text-white text-center text-base sm:text-sm sm:whitespace-nowrap">Total AutoRun Plus Income</h2>
                                            </div>
                                            <span className="text-white text-center text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">{this.state.userIncomeAutoRun2} USDT</span>
                                        </div>

                                        </div>
                                    <div className="flex mr-10 space-x-10 lg:mr-0 lg:mt-10 sm:mt-5 sm:space-x-5 lg:order-2 sm:overflow-auto sm:w-full">
                                        <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem"}}
                                            className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-info block-base sm:mobile-infoblock-base">
                                            <div className="flex justify-center">
                                                <h2 className="text-white text-center text-base sm:text-sm sm:whitespace-nowrap">Total AutoRun 3 Income</h2>
                                            </div>
                                            <span className="text-white text-center text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">{this.state.userIncomeAutoRun3} USDT</span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="flex justify-center w-full mt-10 sm:mt-5 sm:px-5">
                            {(this.state.userId != 1) &&
                                <div className="flex justify-center w-full">
                                    <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem" }}
                                        className="flex flex-col p-5 bg-black-light rounded desktop-info block-base sm:mobile-infoblock-base items-center w-full max-w-md">
                                        <h2 className="text-white text-center text-base sm:text-sm sm:whitespace-nowrap">Eligibility Days left</h2>
                                        <span className="text-white text-center text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">{this.state.eligibilityTime}</span>
                                        <button style={{ background: 'white' }}
                                            className="flex justify-center items-center text-center text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-2 bg-blue-600 hover:bg-blue-400 active:bg-active-red-600 mt-3 py-2 !px-10 sm:py-2 sm:mt-7.5"
                                            onClick={this.activateForNext30Days} id="nextButton">Activate For Next 30 days</button>
                                    </div>
                                </div>
                            }
                            </div>
                            {/* Top panel Partners, Team, Profit ration, Profits View inside above div */}

                            {/* Matrix name inside below div */}
                            <div style={{ marginTop: "50px", fontStyle: "italic" }} className="flex flex-wrap justify-between">
                                
                                <div className="flex flex-col w-full flex-wrap sm:px-5">
                                    <div className="flex items-center mb-1.5 sm:mb-2.5">
                                        <div className="flex">
                                            <a className="mr-1.5 text text-white-300 sm:text-sm" href="/dashboard?user=1">
                                                <span className="hover:text-white-500"></span>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-center flex-wrap">
                                        <div className="flex">
                                            <span className="text-two-half text-white font-medium mr-2 sm:text-2xl whitespace-nowrap">Top Business Infinity</span></div>
                                        </div>
                                </div>
                            </div>
                            {/* Matrix name inside above div */}

                            {/* Matrix Tree and Levels inside below div */}
                            <div style={{ backgroundImage: "url('/logo/bg5.webp')", backgroundSize: "100%", backgroundPosition: "center", backgroundRepeat: "no-repeat" }} className="flex overflow-hidden relative w-full flex-col bg-gray-800 rounded p-7.5 pb-5 sm:p-5 sm:pl-2.5 sm:pr-2.5 sm:rounded-none">
                                <div className="flex z-10 flex-wrap -m-2 sm:-mx-px mb-7.5 sm:justify-evenly justify-evenly">
                                    
                                    { this.state.idsWithLevels.map((ids, index) => {
                                        const isActive = (index+1) <= this.state.levelBought;
                                        const isUserRegisteredInAutoRun = this.state.isUserRegisteredInAutoRun;
                                        const isUserRegisteredInAutoRun2 = this.state.isUserRegisteredInAutoRun2;
                                        const isUserRegisteredInAutoRun3 = this.state.isUserRegisteredInAutoRun3;
                                        // const isActive = true;

                                        return <Slot key={index} ids={ids} index={index}
                                            levelPrices={levelPrices}
                                            userId={this.state.userId}
                                            isAuthorized={this.state.isAuthorized}
                                            reinvestCounts={this.state.reinvestCounts}
                                            onSlotClick={this.props.onSlotClick}
                                            onAutoRunClick={this.props.onAutoRunClick}
                                            onBuyLevel={this.handleBuyLevel}
                                            isActive={isActive}
                                            isUserRegisteredInAutoRun={isUserRegisteredInAutoRun}
                                            isUserRegisteredInAutoRun2={isUserRegisteredInAutoRun2}
                                            isUserRegisteredInAutoRun3={isUserRegisteredInAutoRun3}
                                        />
                                    })}
                                {(this.state.isUserRegisteredInAutoRun) ? (
                                    <a onClick={() => this.props.onAutoRunClick(this.state.userId)}>
                                        <div style={{ width: "200px", borderRadius: "0 3rem 3rem 3rem", backgroundColor: "black" }}
                                            className="relative overflow-hidden flex flex-col w-180px min-h-180px sm:w-158px sm:min-h-180px p-5 m-2 justify-between  bg-gray-900 hover:bg-gray-800  sm:space-y-1.5">
                                            <div className="flex w-full justify-between">
                                                <div className="flex space-x-1.5 items-center">
                                                    <span className="text-white-500 text-base sm:text-sm slot-title">
                                                        AutoRun 1
                                                    </span>
                                                </div>
                                                <span className="flex items-center text-white text-base sm:text-sm">
                                                    <img
                                                        src="/logo/USDTSmall.png"
                                                        className="w-3 h-3 mr-1.5"
                                                        alt=""
                                                    />
                                                    625
                                                </span>
                                            </div>

                                            <div className="flex w-full justify-center h-full items-center pb-8">
                                                <div className="px-4 py-2 text-black-800 bg-white mx-auto text-center rounded-full text-sm font-weight-500">
                                                    <span style={{ color: "black", fontSize: "15px"  }}>Purchased<i style={{ color: "green", fontSize: "20px" }} className="las la-check text-xl"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                ) : (
                                    <a onClick={() => this.handleAutorunBuy()}>
                                        <div style={{ width: "200px", borderRadius: "0 3rem 3rem 3rem", backgroundColor: "black" }}
                                            className="relative overflow-hidden flex flex-col w-180px min-h-180px sm:w-158px sm:min-h-180px p-5 m-2 justify-between  bg-gray-900 hover:bg-gray-800  sm:space-y-1.5">
                                            <div className="flex w-full justify-between">
                                                <div className="flex space-x-1.5 items-center">
                                                    <span className="text-white-500 text-base sm:text-sm slot-title">
                                                        AutoRun 1
                                                    </span>
                                                </div>
                                                <span className="flex items-center text-white text-base sm:text-sm">
                                                    <img
                                                        src="/logo/USDTSmall.png"
                                                        className="w-3 h-3 mr-1.5"
                                                        alt=""
                                                    />
                                                    625
                                                </span>
                                            </div>

                                            <div className="flex w-full justify-center h-full items-center pb-8">
                                                <div className="px-4 py-2 text-black-800 bg-white mx-auto text-center rounded-full text-sm font-weight-500">
                                                    <i style={{ color: "black" }} className="las la-lock text-xl"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                )}
                                {(this.state.isUserRegisteredInAutoRun2) ? (
                                    <a onClick={() => this.props.onAutoRun2Click(this.state.userId)}>
                                        <div style={{ width: "200px", borderRadius: "0 3rem 3rem 3rem", backgroundColor: "black" }}
                                            className="relative overflow-hidden flex flex-col w-180px min-h-180px sm:w-158px sm:min-h-180px p-5 m-2 justify-between  bg-gray-900 hover:bg-gray-800  sm:space-y-1.5">
                                            <div className="flex w-full justify-between">
                                                <div className="flex space-x-1.5 items-center">
                                                    <span className="text-white-500 text-base sm:text-sm slot-title">
                                                        AutoRun Plus
                                                    </span>
                                                </div>
                                                <span className="flex items-center text-white text-base sm:text-sm">
                                                    <img
                                                        src="/logo/USDTSmall.png"
                                                        className="w-3 h-3 mr-1.5"
                                                        alt=""
                                                    />
                                                    125
                                                </span>
                                            </div>

                                            <div className="flex w-full justify-center h-full items-center pb-8">
                                                <div className="px-4 py-2 text-black-800 bg-white mx-auto text-center rounded-full text-sm font-weight-500">
                                                    <span style={{ color: "black", fontSize: "15px"  }}>Purchased<i style={{ color: "green", fontSize: "20px" }} className="las la-check text-xl"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                ) : (
                                    <a onClick={() => this.handleAutorun2Buy()}>
                                        <div style={{ width: "200px", borderRadius: "0 3rem 3rem 3rem", backgroundColor: "black" }}
                                            className="relative overflow-hidden flex flex-col w-180px min-h-180px sm:w-158px sm:min-h-180px p-5 m-2 justify-between  bg-gray-900 hover:bg-gray-800  sm:space-y-1.5">
                                            <div className="flex w-full justify-between">
                                                <div className="flex space-x-1.5 items-center">
                                                    <span className="text-white-500 text-base sm:text-sm slot-title">
                                                        AutoRun Plus
                                                    </span>
                                                </div>
                                                <span className="flex items-center text-white text-base sm:text-sm">
                                                    <img
                                                        src="/logo/USDTSmall.png"
                                                        className="w-3 h-3 mr-1.5"
                                                        alt=""
                                                    />
                                                    125
                                                </span>
                                            </div>

                                            <div className="flex w-full justify-center h-full items-center pb-8">
                                                <div className="px-4 py-2 text-black-800 bg-white mx-auto text-center rounded-full text-sm font-weight-500">
                                                    <i style={{ color: "black" }} className="las la-lock text-xl"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                )}
                                {(this.state.isUserRegisteredInAutoRun3) ? (
                                    <a onClick={() => this.props.onAutoRun3Click(this.state.userId)}>
                                        <div style={{ width: "200px", borderRadius: "0 3rem 3rem 3rem", backgroundColor: "black" }}
                                            className="relative overflow-hidden flex flex-col w-180px min-h-180px sm:w-158px sm:min-h-180px p-5 m-2 justify-between  bg-gray-900 hover:bg-gray-800  sm:space-y-1.5">
                                            <div className="flex w-full justify-between">
                                                <div className="flex space-x-1.5 items-center">
                                                    <span className="text-white-500 text-base sm:text-sm slot-title">
                                                        AutoRun 3
                                                    </span>
                                                </div>
                                                <span className="flex items-center text-white text-base sm:text-sm">
                                                    <img
                                                        src="/logo/USDTSmall.png"
                                                        className="w-3 h-3 mr-1.5"
                                                        alt=""
                                                    />
                                                    125
                                                </span>
                                            </div>

                                            <div className="flex w-full justify-center h-full items-center pb-8">
                                                <div className="px-4 py-2 text-black-800 bg-white mx-auto text-center rounded-full text-sm font-weight-500">
                                                    <span style={{ color: "black", fontSize: "15px"  }}>Purchased<i style={{ color: "green", fontSize: "20px" }} className="las la-check text-xl"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                ) : (
                                    <a onClick={() => this.handleAutorun3Buy()}>
                                        <div style={{ width: "200px", borderRadius: "0 3rem 3rem 3rem", backgroundColor: "black" }}
                                            className="relative overflow-hidden flex flex-col w-180px min-h-180px sm:w-158px sm:min-h-180px p-5 m-2 justify-between  bg-gray-900 hover:bg-gray-800  sm:space-y-1.5">
                                            <div className="flex w-full justify-between">
                                                <div className="flex space-x-1.5 items-center">
                                                    <span className="text-white-500 text-base sm:text-sm slot-title">
                                                        AutoRun 3
                                                    </span>
                                                </div>
                                                <span className="flex items-center text-white text-base sm:text-sm">
                                                    <img
                                                        src="/logo/USDTSmall.png"
                                                        className="w-3 h-3 mr-1.5"
                                                        alt=""
                                                    />
                                                    125
                                                </span>
                                            </div>

                                            <div className="flex w-full justify-center h-full items-center pb-8">
                                                <div className="px-4 py-2 text-black-800 bg-white mx-auto text-center rounded-full text-sm font-weight-500">
                                                    <i style={{ color: "black" }} className="las la-lock text-xl"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                )}
                                </div>
                                {/* <div className="flex items-center flex-wrap z-10">
                                    <div
                                        className="flex items-center text-white-500 mb-5 mr-7.5 sm:items-start sm:mb-2.5 sm:pr-2.5 sm:mr-0 sm:w-1/2 sm:order-2">
                                        <div className="w-5 h-5 flex-shrink-0 mr-2.5 rounded-full bg-white"></div><span
                                            className="text-base sm:text-sm">Direct partner</span>
                                    </div>
                                    <div
                                        className="flex items-center text-white-500 mb-5 mr-7.5 sm:items-start sm:mb-2.5 sm:pr-2.5 sm:mr-0 sm:w-1/2 sm:order-4">
                                        <div className="w-5 h-5 flex-shrink-0 mr-2.5 rounded-full bg-light-blue"></div><span
                                            className="text-base sm:text-sm">Spillover from above</span>
                                    </div>
                                    <div
                                        className="flex items-center text-white-500 mb-5 mr-7.5 sm:items-start sm:mb-2.5 sm:pr-2.5 sm:mr-0 sm:w-1/2 sm:order-6">
                                        <div className="w-5 h-5 flex-shrink-0 mr-2.5 rounded-full bg-orange"></div><span
                                            className="text-base sm:text-sm">Spillover from below</span>
                                    </div>
                                    <div
                                        className="flex items-center text-white-500 mb-5 mr-7.5 sm:items-start sm:mb-2.5 sm:pr-2.5 sm:mr-0 sm:w-1/2 sm:order-7">
                                        <div className="w-5 h-5 flex-shrink-0 mr-2.5 rounded-full bg-green-500"></div><span
                                            className="text-base sm:text-sm">OverTake</span>
                                    </div>
                                    <div
                                        className="flex items-center text-white-500 mb-5 mr-7.5 sm:items-start sm:mb-2.5 sm:pr-2.5 sm:mr-0 sm:w-1/2 sm:order-1">
                                        <svg className="w-5 h-5 mr-2.5 stroke-current text-white" viewBox="0 0 16 16"
                                            fill="none" stroke="#fff" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M6 7.333A2.667 2.667 0 1 0 6 2a2.667 2.667 0 0 0 0 5.333ZM2 14v-1.333A2.667 2.667 0 0 1 4.667 10h2.666A2.667 2.667 0 0 1 10 12.667V14M10.667 2.086a2.667 2.667 0 0 1 0 5.167M14 14v-1.333a2.667 2.667 0 0 0-2-2.567"
                                                strokeWidth="1.333" strokeLinecap="round" strokeLinejoin="round">
                                            </path>
                                        </svg><span className="text-base sm:text-sm">Partners on level</span></div>
                                    <div
                                        className="flex items-center text-white-500 mb-5 mr-7.5 sm:items-start sm:mb-2.5 sm:pr-2.5 sm:mr-0 sm:w-1/2 sm:order-3">
                                        <svg className="w-5 h-5 mr-2.5 stroke-current text-white" viewBox="0 0 20 20"
                                            fill="none" stroke="#2CFF4E" xmlns="http://www.w3.org/2000/svg">
                                            <path clipRule="evenodd"
                                                d="M6.354 3.818a7.25 7.25 0 0 1 10.808 5.28.5.5 0 1 1-.99.137A6.25 6.25 0 0 0 4.551 7h2.115a.5.5 0 0 1 0 1H3.333a.5.5 0 0 1-.5-.5V4.167a.5.5 0 1 1 1 0v2.086a7.25 7.25 0 0 1 2.521-2.435ZM3.265 10.338a.5.5 0 0 1 .564.427A6.25 6.25 0 0 0 15.449 13h-2.116a.5.5 0 1 1 0-1H16.667a.5.5 0 0 1 .5.5v3.333a.5.5 0 1 1-1 0v-2.086a7.25 7.25 0 0 1-13.329-2.845.5.5 0 0 1 .427-.564Z">
                                            </path>
                                        </svg><span className="text-base sm:text-sm">Level Cycle</span></div>
                                </div> */}
                            </div>
                            {/* Matrix Tree and Levels inside above div */}

                            {/* Activities, Transactions and other info inside below div */}
                            
                            {/* Activities, Transactions and other info inside above div */}
                        </div>
                        {/* Top Panel, Matrix levels and all activies inside above div */}
                        <footer style={{ backgroundColor: "rgba(0, 0, 0, 0)"}}
                            className="flex lg:flex-col items-center mt-auto justify-between lg:justify-start lg:items-start py-10 w-full lg:p-5 lg:pb-9 pb-0 lg:pb-0 z-10">
                            <div className="hidden lg:block mb-7.5">
                                <div className="flex space-x-5 w-full"><a
                                        className="w-6 h-6 sm:w-7 sm:h-7 flex justify-center items-center rounded-full bg-white-100 hover:bg-white-300"
                                        target="_blank" href="https://t.me/tbi_2024"><svg
                                            className="w-3 h-3 sm:w-4 sm:h-4" viewBox="0 0 14 12" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path clipRule="evenodd"
                                                d="M11.915.776.841 5.168a.4.4 0 0 0 .03.755l2.79.864 1.133 3.503a.4.4 0 0 0 .653.17l1.64-1.523 3.11 2.29a.4.4 0 0 0 .627-.231l2.166-9.294a.8.8 0 0 0-1.075-.926Zm-6.483 6.74-.346 2.072-.8-2.901 7.816-5.1-6.67 5.929Z"
                                                fill="#fff"></path>
                                        </svg></a>

                                </div>
                            </div>
                            {/* <div id="google_translate_element"></div> */}
                            {/* <div id="google_translate_element"></div> */}

                            {/* <span className="text-white-500 text-xs font-normal lg:mb-2.5">© 2023 All Rights
                                Reserved</span> */}
                        
                        </footer>
                    </div>
            </div>
        );
    }
}
 
export default withWrapper(Dashboard);